import script from "./Excel2JSON.vue?vue&type=script&setup=true&lang=js"
export * from "./Excel2JSON.vue?vue&type=script&setup=true&lang=js"

import "./Excel2JSON.vue?vue&type=style&index=0&id=26db5594&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26db5594"]])

export default __exports__